import { IoArrowUpOutline, IoArrowDownOutline } from 'react-icons/io5';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const CardSmall = ({ amount, color, title, value }) => {
  const isGreen = color === 'green';
  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.bottom}>
        <h1 className={styles.amount}>{amount}</h1>
        <div
          className={`${styles.indicator} ${
            isGreen ? styles.indicatorGreen : styles.indicatorRed
          }`}
        >
          <span className={styles.indicatorValue}>{value}</span>
          {isGreen ? (
            <IoArrowUpOutline size={16} />
          ) : (
            <IoArrowDownOutline size={16} />
          )}
        </div>
      </div>
    </div>
  );
};

CardSmall.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.string,
};

export default CardSmall;
